import { useEffect, useState } from 'react';
import { ref, list, listAll, getDownloadURL } from "firebase/storage"
import { db, storage } from '../../../../../../../../firebase';
import { Button, Card, CardActions, CardMedia, CircularProgress, Grid, IconButton, Typography, makeStyles } from '@material-ui/core';
import { Add, Delete, Edit, Star } from '@material-ui/icons';
import { useDispatch, useSelector } from 'react-redux';
import { showAddItemPhotosDialog } from '../item-photos-add/item-photos-add-slice';
import { getItemPhotosService } from './item-photos-list-service';

const useStyles = makeStyles((theme) => ({
  button: {
      background: "#111111",
      color: "#fbbbd3",
      '&:hover': {
          backgroundColor: '#fbbbd3',
          color: '#111111',
      },
  },
  buttonText: {
      color: "#111111",
      '&:hover': {
          backgroundColor: '#fbbbd3',
          color: '#111111',
      },
  },
  text: {
      color: "#111111",
  },
  title: {
      background:"#111111",
  },
  typography: {
    color:"#111111",
  }
}));

const ItemPhotosListLoading = () => {
  const classes = useStyles();
  return (
    <>
    <div style={{ display: "flex", alignItems: "center", marginBottom: 10}}>
        <Button
            variant="contained"
            className={classes.button}
            startIcon={<Add/>}
            disabled
        >
            Add
        </Button>
      </div>
      <div style={{ display: "center", alignItems: "center", marginTop: 10}}>
        <CircularProgress color="inherit" />
      </div>

    </>
  );
};

export default ItemPhotosListLoading;
